var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('ul',{staticClass:"g-timeline"},_vm._l((_vm.data),function(item,i){return _c('li',{key:i,staticClass:"item"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(item.date))]),_c('p',[_vm._v(_vm._s(item.content))]),(item.reject)?_c('div',{staticClass:"reject"},[_vm._v(_vm._s(item.reject))]):_vm._e()])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }